import { InfiniteData, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { Bonus } from '../../../../../../types/bonus';
import { CachedProfileBonuses } from '../../../cache/mutators/bonus';
import { QueryKey } from '../../../hooks/types';
import { ApiResponse } from '../../../types/api';

export const useFindBonus = () => {
	const queryClient = useQueryClient();

	return useCallback(
		(id: string) => {
			const data = queryClient.getQueriesData<InfiniteData<ApiResponse<Bonus[]>>>([QueryKey.BonusesInfinite]);
			const allBonuses = data.flatMap(([, cache]) => cache?.pages.flatMap((page) => page.data.result));

			const topLevelBonus = allBonuses.find((bonus) => bonus?.id === id);
			if (topLevelBonus) {
				return topLevelBonus;
			}

			for (const bonus of allBonuses) {
				if (bonus?.child_bonuses) {
					const childBonus = bonus.child_bonuses.find((child) => child.id === id);
					if (childBonus) {
						return childBonus;
					}
				}
			}

			const profileData = queryClient.getQueriesData<CachedProfileBonuses>([QueryKey.ProfileBonuses]);
			const profileBonuses = profileData.flatMap(([, cache]) => cache?.pages.flatMap((page) => page.bonuses));

			const profileBonus = profileBonuses.find((bonus) => bonus?.id === id);
			if (profileBonus) {
				return profileBonus;
			}

			for (const bonus of profileBonuses) {
				if (bonus?.child_bonuses) {
					const childBonus = bonus.child_bonuses.find((child) => child.id === id);
					if (childBonus) {
						return childBonus;
					}
				}
			}

			return undefined;
		},
		[queryClient]
	);
};
